import { ref } from 'vue';

export function useCloudApi(httpAPI, formatResp = (obj) => obj) {
  const isLoading = ref(false);
  const data = ref(null);
  const error = ref(null);

  const makeAPICall = async (params) => {
    try {
      isLoading.value = true;
      const resp = await httpAPI(params);

      data.value = formatResp(resp);
      error.value = null;
      isLoading.value = false;
    } catch (err) {
      console.log('error in cloud API hook: ', err);
      error.value = err;
      data.value = null;
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    data,
    error,
    makeAPICall,
  };
}
